import React, { Component } from "react";

import HeroSection from "../components/HeroSection/HeroSectionResetPassword";

class ResetPassword extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="main">
          <HeroSection />
        </div>  
      </React.Fragment>
    );
  }
}

export default ResetPassword;
